export default __webpack_public_path__ + "static/media/vacs-list.31e56092.svg";